import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMN = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 50c3.058 0 5.987-.55 8.695-1.555L34.782 25 33.695 1.555A24.947 24.947 0 0 0 25 0c-3.058 0-5.988.55-8.696 1.555L15.217 25l1.087 23.445A24.944 24.944 0 0 0 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M0 25c0 10.75 6.784 19.913 16.304 23.445V1.555C6.784 5.088 0 14.251 0 25ZM33.696 1.555v46.89C43.216 44.913 50 35.75 50 25S43.216 5.088 33.696 1.555Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M11.957 25h2.174v8.696h-2.174V25ZM3.262 25h2.174v8.696H3.262V25ZM8.697 30.433a2.174 2.174 0 1 0 0-4.348 2.174 2.174 0 0 0 0 4.348ZM8.695 21.738a1.087 1.087 0 1 0 0-2.174 1.087 1.087 0 0 0 0 2.174ZM6.524 31.521h4.347v2.174H6.524v-2.174ZM6.524 22.825h4.347V25H6.524v-2.174ZM8.697 13.042l.77 2.37h2.491l-2.015 1.464.77 2.369-2.016-1.464-2.015 1.464.77-2.37-2.016-1.463h2.491l.77-2.37Z"
}));
FlagMN.displayName = 'FlagMN';
export default withFlagWrapper(FlagMN);
//# sourceMappingURL=index.js.map